import * as api from '../../api';

export const fetchAppointmentActions = api.fetchActions('appointment-details', 'fetch-appointment');
export const cancelAppointmentActions = api.fetchActions('appointment-details', 'cancel-appointment');

export const actionTypes = {
  ...fetchAppointmentActions.actionTypes,
  ...cancelAppointmentActions.actionTypes,
  FINISH_REDIRECT: 'appointment-details.finish-redirect',
  SHOW_CANCEL_MODAL: 'appointment-details.show-cancel-modal',
  HIDE_CANCEL_MODAL: 'appointment-details.hide-cancel-modal',
};

/**
 * Fetches a single appointment 
 * @param {number} appointmentId id of appointment to retrieve
 */
 export const fetchAppointment = (appointmentId) =>
   api.getThunk(`/scheduler/appointment-by-id?apptId=${appointmentId}`, null, fetchAppointmentActions);

/**
 * Deletes an appointment 
 * @param {number} appointmentId id of appointment to delete
 * @param {number} staffId id of staff user to delete appointment with
 */
export const cancelAppointment = (appointmentId, staffId) =>
  api.deleteThunk(`/scheduler/cancel-appointment?appointmentId=${appointmentId}&staffId=${staffId}`, cancelAppointmentActions);

/**
 * Shows the cancel appointment confirmation modal
 */
export const showCancelModal = () => {
    return { type: actionTypes.SHOW_CANCEL_MODAL }
}

/**
 * Hides the cancel appointment confirmation modal
 */
export const hideCancelModal = () => {
    return { type: actionTypes.HIDE_CANCEL_MODAL }
}

/**
 * Clean up flags after redirecting
 */
export const finishRedirect = () => {
  return { type: actionTypes.FINISH_REDIRECT }
}


// WEBPACK FOOTER //
// src/scheduler/appointmentDetails/appointmentDetails.actions.js